import { ThemeProvider } from "styled-components";
import App from "./Components/App/App";
import theme from "./theme";
import { userBalanceContext } from "./context/userBalanceContext";
import {buyTokenPopUpContext} from './context/buyTokenPopUpContext'
import { userInfoContext } from "./context/userInfoContext";
import { useEffect, useState } from "react";
import { socket } from "./config/socket";
import { SocketContext } from "./context/socketContext";
function Root() {
  const [userBalance, setUserBalance] = useState({
    MLDBalance: 0,
    LORDBalance: 0,
    MATICBalance: 0,
    USDTBalance: 0,
    MLD: 0,
    LORD: 0,
    MATIC: 0,
    USDT: 0,
    LORDUSD: 0,
    MATICUSD: 0,
    MLDUSD: 0,
    MLDBalanceDec: 0,
    LORDBalance: 0,
    loading:true,
  });
  const [isBuyOpen, setIsBuyOpen] = useState(false);
  const [popUpCurrency,setPopUpCurrency]=useState('');
  useEffect(()=>{
    if(!socket.connected){
      socket.connect();
    }
    socket.on("connect",()=>{
      console.log('socket connected',socket.id)
    })
    socket.on("disconnect",()=>{
      console.log("socket disconnected")
    })
    return ()=>{
      socket.off("connect");
      socket.off("disconnect")
    }
  },[])
  const [userAccInfo, setUserAccInfo] = useState(() => {
    const savedUserInfo = localStorage.getItem("userinfo");
    try {
      return savedUserInfo ? (savedUserInfo) : null; 
    } catch (error) {
      console.error("Error parsing user info from localStorage:", error);
      return null; 
    }
  });

  return (
    <div>
      <SocketContext.Provider value={socket}>
        <userInfoContext.Provider value={{userAccInfo,setUserAccInfo}}>
      <userBalanceContext.Provider value={{ userBalance, setUserBalance }}>
        <buyTokenPopUpContext.Provider value={{ isBuyOpen, setIsBuyOpen,popUpCurrency,setPopUpCurrency }}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </buyTokenPopUpContext.Provider>
      </userBalanceContext.Provider>
      </userInfoContext.Provider>
      </SocketContext.Provider>
    </div>
  );
}

export default Root;
